var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10734 22.9376L18.9073 22.9376C20.5873 22.9376 22.0273 21.4376 22.0273 19.6876L22.0273 5.31256C22.0273 3.56256 20.5873 2.06256 18.9073 2.06256L5.10734 2.06256C3.42734 2.06256 1.98734 3.56256 1.98734 5.31256L1.98734 19.6876C1.98734 21.4376 3.42734 22.9376 5.10734 22.9376ZM15.3073 17.5001L11.2873 12.9376C11.1073 12.6876 11.1073 12.3126 11.2873 12.0626L15.3073 7.50006C15.5473 7.25006 15.9673 7.18756 16.2073 7.43756C16.3873 7.62506 16.4473 7.81256 16.4473 7.93756C16.4473 8.12506 16.3873 8.31256 16.2673 8.43756L12.6673 12.5001L16.2673 16.5626C16.5073 16.8751 16.5073 17.2501 16.2073 17.5626C15.9673 17.8126 15.5473 17.7501 15.3073 17.5001ZM11.7673 17.5001L7.74734 12.9376C7.50734 12.6876 7.50734 12.3126 7.74734 12.0626L11.7673 7.50006C12.0073 7.25006 12.3673 7.18756 12.6673 7.43756C12.7873 7.62506 12.8473 7.81256 12.8473 7.93756C12.8473 8.12506 12.7873 8.31256 12.7273 8.43756L9.12734 12.5001L12.7273 16.5626C12.9673 16.8751 12.9073 17.2501 12.6673 17.5626C12.3673 17.8126 12.0073 17.7501 11.7673 17.5001Z",
    fill: "#7688A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarless);
export default __webpack_public_path__ + "static/media/sidebarless.86fde735ab770ab9539509dadea30742.svg";
export { ForwardRef as ReactComponent };